import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Python = () => {
  return (
    <StartInterviewLayout type="python"/>
  )
}

export default Python;